(async () => {
	await import('$components/DstReadinglist');
	await import('$components/DstReadlater');
	await import('$components/DstRlTimestamp');
})();
